import dom from '../../../helpers/dom';
import scroll from '../../../helpers/scroll';
import styles from '../../../helpers/styles';
import headerElements from './headerElements';

const menuMobileToggle = () => {
  const toggleButtonClass = 'js-header-mobile-menu-toggle';
  const menuClass = 'js-header-mobile-menu';
  const iconOpenClass = `${toggleButtonClass}__icon--open`;
  const iconCloseClass = `${toggleButtonClass}__icon--close`;

  let toggleButton;
  let mobileMenu;
  let iconOpen;
  let iconClose;
  let isOpen = false;

  const hideMenu = () => {
    isOpen = false;
    styles.hideElement(mobileMenu);
    styles.showElement(iconOpen);
    styles.hideElement(iconClose);
    styles.showElement(headerElements.getMobileStickyContainer());
    scroll.enableBodyScroll();
  };

  const showMenu = () => {
    isOpen = true;
    styles.showElement(mobileMenu);
    styles.hideElement(iconOpen);
    styles.showElement(iconClose);
    styles.hideElement(headerElements.getMobileStickyContainer());
    scroll.disableBodyScroll();
  };

  const addToggleListener = (event) => {
    event.preventDefault();
    if (!isOpen) {
      showMenu();
    } else {
      hideMenu();
    }
  };

  const init = () => {
    toggleButton = headerElements.getMobileHeader().querySelector(
      dom.classNameToSelector(toggleButtonClass),
    );
    if (toggleButton !== null) {
      mobileMenu = headerElements.getMobileHeader().querySelector(
        dom.classNameToSelector(menuClass),
      );
      iconOpen = toggleButton.querySelector(dom.classNameToSelector(iconOpenClass));
      iconClose = toggleButton.querySelector(dom.classNameToSelector(iconCloseClass));
      toggleButton.addEventListener('click', addToggleListener);
    }
  };

  return {
    init,
  };
};

export default menuMobileToggle();
